"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M18 .75A17.26 17.26 0 0 0 .825 18.105a17.176 17.176 0 1 0 34.35 0A17.259 17.259 0 0 0 18 .75zm0 32.79a15.436 15.436 0 0 1 0-30.87 15.436 15.436 0 0 1 0 30.87z" }),
  React.createElement("path", { d: "M19.215 18.2l8.115-2.3a8.063 8.063 0 0 1-2.115 8.16zm5.07 6.525a9.131 9.131 0 0 1-12.555-.45 8.953 8.953 0 0 1-.345-12.4zM18 16.74l-6.135-5.8a8.589 8.589 0 0 1 8.34-2.34zm.75.615l2.3-8.2a7.921 7.921 0 0 1 3.72 2.04 9.038 9.038 0 0 1 2.25 3.825zm6.915-7.065a10.509 10.509 0 0 0-5.04-2.79l-.2.24a10.153 10.153 0 0 0-9.37 2.66l-.33-.3a10.735 10.735 0 1 0 15.18 15.18l-.3-.3a10.3 10.3 0 0 0 2.595-9.54l.3-.75a10.852 10.852 0 0 0-2.835-4.4z" })
);

